export default __webpack_public_path__ + "static/media/break-default.34109e93.svg";